module.exports = __webpack_public_path__ + "cfd2b05234e2d21d736a2a4b70635354.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-RegItalic.woff
// module id = 420
// module chunks = 0